<template>
  <div>
    <div class="picker-outer">
      <div class="picker-label">
        Location:
      </div>
      <location-picker :location="location" v-on:locationChange="locationChange"></location-picker>
    </div>


    <div class="picker-outer">
      <div class='picker-label picker-label-party-size'>
        Party Size:
      </div>
      <party-size-picker :party-size="partySize" v-on:partySizeChange="partySizeChange"></party-size-picker>
    </div>


    <div class="picker-outer">
      <div class="picker-label">
        Date:
      </div>
      <el-date-picker
        id="date-picker"
        class="date-picker"
        size="small"
        format="ddd, MM-dd-yyyy"
        v-model="date"
        @change="dateChange"
        :editable="false"
        :picker-options="datePickerOptions"
        :clearable="false">
      </el-date-picker>
    </div>


    <div class="picker-outer" v-if="canTakeRes">
      <div class="picker-label">
        Time:
      </div >
      <el-time-select
        id="time-picker"
        class="time-picker"
        size="small"
        :clearable="false"
        :editable="false"
        v-model="time"
        v-show="!loadTimes"
        :picker-options="timePickerOptions"
        @change="timeChange"
        placeholder="Select time">
      </el-time-select>
      <div id="load-times" v-show="loadTimes">
        loading times...
      </div>
    </div>


    <div v-else class="picker-outer">
      <div class="picker-label">
        Time:
      </div >
      <div id="restaurant-closed">
        None for this Day
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import partySizePicker from '@comp/partySizePicker'
import locationPicker from '@comp/locationPicker'

export default {
  name: "userInfo",
  components: {
    partySizePicker,
    locationPicker,
  },
  props: ['closed'],
  data() {
    return {
      loadTimes: false,
      timePickerOptions: {
        start: null,
        end: null,
        step: '00:30',
      },

      datePickerOptions: {
        disabledDate: this.dateNotReservable,
      },
    }
  },
  computed: {
    location: {
      get() {
        return this.$store.state.availability.location
      },
      set( val ) {
        this.$store.commit( 'availability/UPDATE_LOCATION', val )
      }
    },
    date: {
      get() {
        return this.$store.state.availability.date
      },
      set( val ) {
        this.$store.commit( 'availability/UPDATE_DATE', val )
      }
    },
    partySize: {
      get() {
        return this.$store.state.availability.partySize
      },
      set( val ) {
        this.$store.commit( 'availability/UPDATE_PARTY_SIZE', val )
      }
    },
    time: {
      get() {
        return this.$store.state.availability.time
      },
      set( val ) {
        this.$store.commit( 'availability/UPDATE_TIME', val )
      }
    },
    firstTimeslot: {
      get() {
        return this.$store.state.availability.firstTimeslot
      },
      set( val ) {
        this.$store.commit( 'availability/UPDATE_FIRST_TIMESLOT', val )
      }
    },
    lastTimeslot: {
      get() {
        return this.$store.state.availability.lastTimeslot
      },
      set( val ) {
        this.$store.commit( 'availability/UPDATE_LAST_TIMESLOT', val )
      }
    },
    canTakeRes() {
      if ( parseFloat( this.firstTimeslot ) > parseFloat( this.lastTimeslot ) ) {
        return false
      }
      return true
    },
  },
  watch: {
    firstTimeslot() {
      this.updateTimePicker()
    },
    lastTimeslot() {
      this.updateTimePicker()
    }
  },
  methods: {
    updateTimePicker() {
      Vue.set( this.timePickerOptions, 'end', this.lastTimeslot )
      Vue.set( this.timePickerOptions, 'start', this.firstTimeslot ) //either now or firstTimeslot, whichever is later
      this.time = this.timePickerOptions.start

    },
    async locationChange( loc ) {
      this.$emit( 'resetSelectedSuggestion')

      this.location = loc
      this.loadTimes = true

      await this.$store.dispatch( 'availability/getUpdatedTimes', { location: this.location, date: this.date } )
      this.loadTimes = false
    },
    partySizeChange( ps ) {
      this.$emit( 'resetSelectedSuggestion')
      this.partySize = ps
    },
    async dateChange() {
      this.$emit( 'resetSelectedSuggestion')

      this.loadTimes = true
      await this.$store.dispatch( 'availability/getUpdatedTimes', { location: this.location, date: this.date } )
      this.loadTimes = false
    },
    timeChange() {
      this.$emit( 'resetSelectedSuggestion')
    },
    currentTime() {
      let now = moment()
      let hour = now.hour()
      let min = now.minutes()

      if ( hour < 12 ) {
        return this.firstTimeslot
      }

      if ( this.firstTimeslot ) {
        var [ ftsHour, ftsMin ] = this.firstTimeslot.split(':')
      } else {
        ftsHour = null; ftsMin = null
      }

      if ( hour >= 12 ) { hour -= 12 }
      if ( ftsHour == 12 ) { ftsHour = 0 }

      if ( ( ftsHour > hour ) || (( ftsHour == hour ) && ( ftsMin > min ) ) ) {
          return this.firstTimeslot
      }

      if ( min < 30 ) {
        min = '30'
      } else {
        min = '00'; hour++
      }

      if ( hour == 0 ) { hour = 12 }
      if ( hour < 10 ) { hour = "0" + hour }

      return ( hour + ':' + min )
    },
    currentTimeslot() {
      let now = moment()
      let hour = now.hour()
      let min = now.minute()

      var decimalHour
      var decimalMin

      if ( hour < 12 ) {
        return ( 0.0 )
      }

      if ( hour >= 12 ) {
        decimalHour = hour - 12
      }

      if ( min < 30 ) {
        decimalMin = 0.5
      } else {
        decimalHour++
        decimalMin = 0.0
      }

      return decimalHour + decimalMin
    },
    todayDate() {
      if ( parseFloat( this.lastTimeslot.replace( ':', '' ) ) > parseFloat( ( this.currentTime() ).replace( ':', '' ) ) ) {
        return moment().startOf( 'day' ).format('MM-DD-YYYY')
      } else {
        return moment().add( 1, 'day').startOf( 'day' ).format('MM-DD-YYYY')
      }
    },
    dateNotReservable( date ) {
      let m_date = moment( date )

      //check for closed dates according to arigatores database
      if ( this.closed.includes( m_date.format('MM-DD-YYYY') ) ) { return true }

      //monkey patch to deal with time change
      if ( m_date.add(3, 'hours').format('MM-DD-YYYY') == moment().add(3, 'hours').format('MM-DD-YYYY') ) { return false }

      //only allow days within a month to be selected
      return !( m_date.isBetween( moment(), moment().add( 1, 'months' ), 'date', 'date' ) || m_date.isSame( moment().startOf( 'day' ), 'day' ) )
    },

  },
  async beforeMount() {
    if ( this.todayDate() != moment().format( 'MM-DD-YYYY' ) ) {
      this.date = this.todayDate()
      this.dateChange()
    } else {
      this.updateTimePicker()
    }
  },
  mounted() {
  }
}

</script>

<style scoped lang="scss">
.picker-outer {
  margin: 0 10px;
  float: left;
  @media screen and (max-width: 768px) {
    margin: 10px 0;
    width: 50%;
    padding-left: 2.5%;
  }
  @media screen and (max-width: 425px) {
    margin: 10px 0;
    width: 100%;
  }

}

.date-picker {
  float: left;
  clear: left;
  width: 150px !important;
  @media screen and (max-width: 768px) {
        width: 95% !important;
  }
  @media screen and (max-width: 425px) {
    width: 100% !important;
  }
}

.time-picker {
  float: left;
  clear: left;
  width: 150px !important;

  @media screen and (max-width: 768px) {
    width: 95% !important;
  }
  @media screen and (max-width: 425px) {
    width: 100% !important;
  }
}

.picker-label {
  float: left;
  font-weight: bold;
  text-align: left;
}

.picker-label-party-size:after {
  @media screen and (max-width: 425px) {
    content: " (including children & infants)";
  }
}

#load-times {
  float: left;
  clear: left;
  width: 150px;
  text-align: left;
  font-family: "Helvetica Neue";
  margin-top: 6px;
  @media screen and (max-width: 768px) {
    margin: 10px 0 0 14px;
    width: 100%;
  }
}

#restaurant-closed {
  float: left;
  clear: left;
  font-weight: normal;
  text-align: left;
  font-size: 13px;
  height: 30px;
  padding: 6px 0 0 10px;
  color: #ad1313;
  border: 1px solid rgb(217, 193, 191);
  border-radius: 4px;
  width: 150px !important;

  @media screen and (max-width: 768px) {
    width: 95% !important;
  }
  @media screen and (max-width: 425px) {
    width: 100% !important;
  }
}

</style>